module.exports = __webpack_public_path__ + "img/user-cancel.b56f1880.svg";